import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import employee from '../class/employee';
import foodWarehouse from '../class/foodWarehouse';
import { formatRpcError } from '../class/jrpc20WSClient';
import swal from 'sweetalert';
import "../styles/DischargePage.css";

// Sezione magazzino alimentare: lista di prelievo di un ordine con inserimento
// dei movimenti. L'accesso e' gia' verificato da RequireQualifica (solo Magazzinieri).
const PickingListPage = () => {
    const navigate = useNavigate();
    const { order_uuid } = useParams();
    const [orderInfo, setOrderInfo] = useState(null);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchData = async () => {
        try {
            const fw = new foodWarehouse();
            const callData = await fw.getPickingList({ order_uuid });
            setOrderInfo(callData?.order || null);
            // "Quantità prelievo" parte sempre vuota: è il movimento corrente.
            const list = (callData?.rows || []).map(r => ({ ...r, movement_input: '' }));
            setRows(list);
        } catch (error) {
            swal("Errore", formatRpcError(error), "error");
        }
    };

    const handleMovementChange = (index, value) => {
        setRows(prev => prev.map((row, i) => i === index ? { ...row, movement_input: value } : row));
    };

    const handleSubmit = async () => {
        const movements = rows
            .map(r => ({ row: r, qty: (r.movement_input !== '' && r.movement_input !== null && r.movement_input !== undefined) ? Number(String(r.movement_input).replace(',', '.')) : 0 }))
            .filter(m => m.qty > 0);

        if (movements.length === 0) {
            swal("Attenzione", "Inserire almeno una quantità di prelievo", "warning");
            return;
        }

        const confirm = await swal({
            title: "Conferma Prelievo",
            text: `Registrare ${movements.length} moviment${movements.length === 1 ? 'o' : 'i'} di prelievo per l'ordine ${orderInfo?.order_production_number || ''}?`,
            icon: "info",
            buttons: ["Annulla", "Conferma"],
        });
        if (!confirm) return;

        setLoading(true);
        try {
            const fw = new foodWarehouse();
            const payloadRows = movements.map(m => ({
                // uuid univoco della riga di prelievo: aggancia il movimento alla riga
                // esatta (stesso componente su lotti diversi resta distinto).
                ordercomponent_uuid: m.row.ordercomponent_uuid || '',
                component_uuid: m.row.component_uuid,
                lotto: m.row.lotto || '',
                movement_quantity: m.qty
            }));

            await fw.savePicking({ order_uuid, rows: payloadRows });

            await swal("Successo", "Prelievo registrato con successo", "success");
            // Come il path produzione: logout dopo la registrazione e ritorno al login.
            new employee().logout();
            navigate('/login');
        } catch (error) {
            swal("Errore", formatRpcError(error), "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="discharge-page">
            <div className="detail-header">
                <button onClick={() => navigate('/orders')} className="btn-indietro">← Indietro</button>
                <h2 className="page-title">Lista di Prelievo</h2>
            </div>

            {orderInfo && (
                <div className="discharge-form">
                    <div className="form-row">
                        <div className="form-group">
                            <label>Ordine:</label>
                            <div>{orderInfo.order_production_number}</div>
                        </div>
                        <div className="form-group">
                            <label>Cliente:</label>
                            <div>{orderInfo.client_name}</div>
                        </div>
                        <div className="form-group">
                            <label>Articolo:</label>
                            <div>{orderInfo.article_descr}</div>
                        </div>
                    </div>
                </div>
            )}

            <div className="discharge-table-container">
                <table>
                    <thead>
                        <tr className='table-head' style={{ backgroundColor: '#003049', color: '#fff', fontWeight: 'bold' }}>
                            <th>Codice</th>
                            <th>Descrizione</th>
                            <th>U.M.</th>
                            <th>Lotto</th>
                            <th>Quantità Richiesta</th>
                            <th>Quantità da Prelevare</th>
                            <th>Quantità Prelievo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={row.component_uuid + '-' + index}>
                                <td>{row.code}</td>
                                <td>{row.description}</td>
                                <td>{row.um}</td>
                                <td>{row.lotto}</td>
                                <td>{row.quantity_display}</td>
                                <td>{row.remaining_display}</td>
                                <td>
                                    <input
                                        type="text"
                                        inputMode="decimal"
                                        className="qty-input"
                                        value={row.movement_input}
                                        onChange={(e) => handleMovementChange(index, e.target.value)}
                                        placeholder="0"
                                    />
                                </td>
                            </tr>
                        ))}
                        {rows.length === 0 && (
                            <tr><td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>Nessun componente per questo ordine</td></tr>
                        )}
                    </tbody>
                </table>
            </div>

            {rows.length > 0 && (
                <div className="discharge-submit">
                    <button className="blue_butt confirm-btn" onClick={handleSubmit} disabled={loading}>
                        {loading ? "Salvataggio..." : "Conferma"}
                    </button>
                </div>
            )}
        </div>
    );
};

export default PickingListPage;
